import React from "react";

export const TextInput = ({ className = "", ...props }) => (
  <input
    {...props}
    className={`w-full px-[14px] py-3 bg-bg2 border border-b0 rounded-[10px] text-[16px] text-t0 outline-none box-border ${className}`}
  />
);
